import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import DieProfileService from '../services/die-profile.service';

export const fetchDieProfileList = createAsyncThunk(
  'dieProfile/fetchDieProfileList',
  async (queryParams, thunkAPI) => {
    try {
      const response = await DieProfileService.getDieProfileList(queryParams);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchDieProfileListByFilter = createAsyncThunk(
  'dieProfile/fetchDieProfileListByFilter',
  async (queryParams, thunkAPI) => {
    try {
      const response =
        await DieProfileService.getDieProfileListByFilter(queryParams);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchDieProfileByOpenWorkOrder = createAsyncThunk(
  'dieProfile/fetchDieProfileByOpenWorkOrder',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await DieProfileService.getDieProfileByOpenWorkOrder(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchDieProfileDropdown = createAsyncThunk(
  'dieProfile/fetchDieProfileDropdown',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await DieProfileService.getDieProfileDropdown(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchDieProfilenumber = createAsyncThunk(
  'dieProfile/fetchDieProfilenumber',
  async ({ die_number }, thunkAPI) => {
    try {
      const response = await DieProfileService.getDieProfileNumber(die_number);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedDieProfileList = createAsyncThunk(
  'dieProfile/fetchArchiveDieProfileList',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await DieProfileService.getDieArchiveProfileList(
        page,
        pagesize,
        search,
        ordering,
        groupId,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const deleteDieImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('die_diagram', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteDieDetailDiagramImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('die_detail_diagram', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const deleteSopDetailDiagramImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('die_sop', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const deleteCustomerApprovedDiagramImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('customer_approved_diagram', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const deleteAutoCadDrawingDiagramImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('autocad_drawing', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const deleteDieManuFacturingDiagramImage = createAsyncThunk(
  'dieProfile/deleteDieImage',
  async ({ id, ImageUrl }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      formPayload.append('die_manufacturing', ImageUrl);

      const response = await DieProfileService.deleteImage(id, formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteDrawingDimensionById = createAsyncThunk(
  'dieProfile/deleteDrawingDimensionById',
  async (id, thunkAPI) => {
    try {
      await DieProfileService.deleteDrawingDimensionByPerticularId(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchDieProfileById = createAsyncThunk(
  'dieProfile/fetchDieProfileById',
  async (dieProfileId, { rejectWithValue }) => {
    try {

      const response = await DieProfileService.getDieProfileById(dieProfileId);

      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const createDieProfile = createAsyncThunk(
  'dieProfile/createDieProfile',
  async ({ values }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      const textPayload = {
        die_number: values.die_number,
        customer_reference_number: values.customer_reference_number,
        description: values?.description,
        die_type: values.die_type,
        dimension1:
          typeof values.dimension1 !== 'undefined'
            ? parseFloat(values.dimension1).toFixed(2)
            : null,
        dimension2:
          values.dimension2 !== undefined &&
            values.dimension2 !== null &&
            values.dimension2 !== ''
            ? parseFloat(values.dimension2).toFixed(2)
            : null,

        dimension3:
          values.dimension3 !== undefined &&
            values.dimension3 !== null &&
            values.dimension3 !== ''
            ? parseFloat(values.dimension3).toFixed(2)
            : null,
        dimension4:
          values.dimension4 !== undefined &&
            values.dimension4 !== null &&
            values.dimension4 !== ''
            ? parseFloat(values.dimension4).toFixed(2)
            : null,
        min_wt_kg_p_mt: values.min_wt_kg_p_mt,
        max_wt_kg_p_mt: values.max_wt_kg_p_mt,
        wt_kg_p_mt: values.wt_kg_p_mt,
        balloon_drawing_dimensions: values?.balloon_drawing_dimensions,
        die_group: parseInt(values.die_group), // Ensure integer values
        die_category: parseInt(values.die_category),
        die_sub_category: parseInt(values.die_sub_category),
        // total_running_qty: values.total_running_qty,
        // total_running_ton: values.total_running_ton,
        remarks: values.remarks,
        deleted: 0, // Default value
      };
      formPayload.append('form_data', JSON.stringify(textPayload));

      const response = await DieProfileService.addDieProfile(formPayload);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const updateDieProfile = createAsyncThunk(
  'dieProfile/updateDieProfile',
  async ({ id, values }, thunkAPI) => {
    try {
      const formPayload = new FormData();
      const textPayload = {
        die_number: values.die_number,
        customer_reference_number: values.customer_reference_number,
        description: values?.description,
        die_type: values.die_type,
        backer_number: values.backer_number,
        dimension1:
          typeof values.dimension1 !== 'undefined'
            ? parseFloat(values.dimension1).toFixed(2)
            : null,
        dimension2:
          values.dimension2 !== undefined &&
            values.dimension2 !== null &&
            values.dimension2 !== ''
            ? parseFloat(values.dimension2).toFixed(2)
            : null,

        dimension3:
          values.dimension3 !== undefined &&
            values.dimension3 !== null &&
            values.dimension3 !== ''
            ? parseFloat(values.dimension3).toFixed(2)
            : null,
        dimension4:
          values.dimension4 !== undefined &&
            values.dimension4 !== null &&
            values.dimension4 !== ''
            ? parseFloat(values.dimension4).toFixed(2)
            : null,
        min_wt_kg_p_mt: values.min_wt_kg_p_mt,
        max_wt_kg_p_mt: values.max_wt_kg_p_mt,
        wt_kg_p_mt: values.wt_kg_p_mt,
        balloon_drawing_dimensions: values?.balloon_drawing_dimensions,
        die_group: parseInt(values.die_group), // Ensure integer values
        die_category: parseInt(values.die_category),
        die_sub_category: parseInt(values.die_sub_category),
        // total_running_qty: values.total_running_qty,
        // total_running_ton: values.total_running_ton,
        remarks: values.remarks,
      };
      formPayload.append('form_data', JSON.stringify(textPayload));
      const response = await DieProfileService.updateDieProfile(
        id,
        formPayload,
      );

      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const updateDieFile = createAsyncThunk(
  'dieProfile/updateDieFile',
  async ({ profileResponse, filename, value }, thunkAPI) => {
    try {
      const validateFile = file => file instanceof File;

      const formPayload = new FormData();

      if (filename === 'die_diagram' && validateFile(value)) {
        formPayload.append('die_diagram', value);
      }
      if (filename === 'die_detail_diagram' && validateFile(value)) {
        formPayload.append('die_detail_diagram', value);
      }
      if (filename === 'die_sop' && validateFile(value)) {
        formPayload.append('die_sop', value);
      }

      if (filename === 'customer_approved_diagram' && validateFile(value)) {
        formPayload.append('customer_approved_diagram', value);
      }
      if (filename === 'autocad_drawing' && validateFile(value)) {
        formPayload.append('autocad_drawing', value);
      }
      if (filename === 'die_manufacturing' && validateFile(value)) {
        formPayload.append('die_manufacturing', value);
      }
      const response = await DieProfileService.updateDieFile(
        profileResponse,
        formPayload,
      );

      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteDieProfile = createAsyncThunk(
  'dieProfile/deleteDieProfile',
  async (id, thunkAPI) => {
    try {
      await DieProfileService.deleteDieProfile(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveDieProfile = createAsyncThunk(
  'dieProfile/unArchiveDieProfile',
  async (id, thunkAPI) => {
    try {
      await DieProfileService.unArchiveDieProfileRecord(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

const initialState = {
  data: [], // List,
  openWorkOrderData: [],
  list: [],
  archiveData: [], // Archive list
  activeProfileRecord: null,
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  loading: false,
  dieProfile: null,
  hasMore: true,
};

const dieProfileSlice = createSlice({
  name: 'dieProfile',
  initialState,
  reducers: {
    setDieProfile: (state, action) => {
      state.dieProfile = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetDieProfileData: state => {
      state.data = []; // This will clear the list
    },
    resetDieProfileOpenWorkOrderData: state => {
      state.openWorkOrderData = []; // This will clear the list
    },
    resetDieProfileList: state => {
      state.list = []; // This will clear the list
    },
    resetCurrentDieProfilePage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDieProfileList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieProfileList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieProfileList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchDieProfileListByFilter.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieProfileListByFilter.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieProfileListByFilter.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchDieProfileDropdown.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieProfileDropdown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieProfileDropdown.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

       builder
      .addCase(fetchDieProfileByOpenWorkOrder.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieProfileByOpenWorkOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.openWorkOrderData = action.payload.data || []; // Update to match your API response
      })
      .addCase(fetchDieProfileByOpenWorkOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchDieProfilenumber.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDieProfilenumber.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchDieProfilenumber.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedDieProfileList.pending, state => {
        state.loading = true;
      })
      .addCase(fetchArchivedDieProfileList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.archiveData = action.payload?.results?.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchArchivedDieProfileList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchDieProfileById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDieProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchDieProfileById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createDieProfile.pending, state => {
        state.status = 'loading';
      })
      .addCase(createDieProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createDieProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(updateDieProfile.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateDieProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updateDieProfile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieProfile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieProfile; // Replace the old group with the updated one
        }
      })
      .addCase(updateDieProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(updateDieFile.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateDieFile.fulfilled, (state, action) => {
        state.status = 'success';
        const updateDieFile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieFile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieFile; // Replace the old group with the updated one
        }
      })
      .addCase(updateDieFile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(deleteDieProfile.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteDieProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteDieProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(unArchiveDieProfile.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveDieProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveDieProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setDieProfile,
  resetDieProfileData,
  resetDieProfileOpenWorkOrderData,
  resetDieProfileList,
  resetCurrentDieProfilePage,
  deleteImage,
} = dieProfileSlice.actions;
export default dieProfileSlice.reducer;
